// Human labels for known action keys — falls back to a generic
// "snake_case -> Title Case" conversion for any action not listed here, so a
// brand new action added anywhere in the backend still shows up readably in
// the filter dropdown without needing a matching frontend change first.
const KNOWN_LABELS = {
  member_invited: 'Member invited',
  member_reinvited: 'Member re-invited',
  member_updated: 'Member updated',
  member_removed: 'Member removed',
}

export function actionLabel(action) {
  if (KNOWN_LABELS[action]) return KNOWN_LABELS[action]
  return action.replaceAll('_', ' ').replace(/^./, (c) => c.toUpperCase())
}
